import { useCallback, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import useMutate from "../../../../../hooks/useMutate";
import { deleteCard } from "../../../../../services/apiCards";

export function useDeleteCard({ cardId, boardId, setShowDetails }) {
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const handleDeleteSuccess = useCallback(() => {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete("card_id");
    nextSearchParams.delete("brd_id");
    const nextSearch = nextSearchParams.toString();

    setLoading(false);
    setShowDelete(false);

    if (typeof setShowDetails === "function") {
      setShowDetails(false);
    }

    if (id) {
      navigate(
        {
          pathname: location.pathname.includes("/feeds/")
            ? `/feeds/${id}`
            : `/board/${id}`,
          search: nextSearch ? `?${nextSearch}` : "",
        },
        { replace: true }
      );
      return;
    }

    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : "",
      },
      { replace: true }
    );
  }, [id, location.pathname, navigate, searchParams, setShowDetails]);

  const handleDeleteError = useCallback(() => {
    setLoading(false);
    setShowDelete(false);
  }, []);

  const { mutate: deleteCardMutate } = useMutate(
    deleteCard,
    ["mineCards", "watching", ["cards", boardId], ["feeds", boardId], "boards"],
    () => {},
    handleDeleteSuccess,
    handleDeleteError,
    handleDeleteError
  );

  const handleDeleteConfirm = useCallback(() => {
    setLoading(true);
    deleteCardMutate(cardId);
  }, [cardId, deleteCardMutate]);

  const handleCardDelete = useCallback((event) => {
    event.stopPropagation();
    setShowDelete(true);
  }, []);

  const handleClose = useCallback((event) => {
    event.stopPropagation();
    setShowDelete(false);
  }, []);

  return {
    handleCardDelete,
    handleClose,
    handleDeleteConfirm,
    loading,
    showDelete,
  };
}
